module.exports = __webpack_public_path__ + "static/HDBR-Cotidiano-6-da3a26b01651e3535c4332c09b8ca944.jpg";